import { Button } from "../../ui/Button"
import {WalletIcon} from "../../../icons/walletIcon"
import { useState } from "react"
import { ApprovedCircled } from "../../../icons/approvedCircled"
import { TooltipComponent } from "../../ui/Tooltip"
import { InfoIcon } from "../../../icons/infoIcon"
import { CreditCardIcon } from "../../../icons/creditCardIcon"
import { ReceiptIcon } from "../../../icons/receiptIcon"
import { CircledLoading } from "../../../icons/circledLoading"
import { RadioGroup, RadioGroupItem } from "../../ui/Radio"
import { useMutation, useQuery } from "@tanstack/react-query"
import { getRfCodeFn } from "../../../transactions/payment/payment"
import { CopyIcon } from "../../../icons/copyIcon"
import { useToast } from "../../ui/Toast/useToast"
import { QuestionIcon } from "../../../icons/questionIcon"
import { useParams } from "react-router-dom"
import { useOnlinePaymentInitit } from "../../../hooks/react-query/usePayment"
import { addOrdersPaymentFn } from "../../../transactions/orders/orders"

export const PaymentSection = ({ paymentData, setCurrentStep }) => {
    const [paymentMethod, setPaymentMethod] = useState();

    const {toast} = useToast()

    const { data } = useQuery({
        queryKey: ['rfCodePayment'],
        queryFn: getRfCodeFn,
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    const { orderId } = useParams();

    const { mutate: paymentInit } = useOnlinePaymentInitit();

    const mutation = useMutation({
        mutationFn: (payload) => addOrdersPaymentFn(payload),
        onSuccess: () => {
            setCurrentStep(2);
        }
      });
    
    const handleCopy = () => {
        navigator.clipboard.writeText(data.data.RFCode);
        toast({
            title: "RF Code",
            description: "The RF Code was succesfully copied to clipboard",
            variant:'success'
          })
    };
    
    const handlePaymentMethod = () => {
        if (paymentMethod === 'RFCode') {
            mutation.mutate({ cncode: orderId, data: { paymentType: "RFCode"} })
        } else if (paymentMethod === 'card') {
            paymentInit({
                    id: orderId,
                    payment_type: "offer",
                    amount: (paymentData.amountWarranty + paymentData.amountInitRent + paymentData.extraChargesVAT).toFixed(2),
            }, {
                onSuccess: (response) => {
                    if (response.exceptions) {
                        if (response.exceptions.length === 0) {
                            console.log(response.data);
                            const data = JSON.parse(response.data);
                            const  url  = data.url;
                            url && window.location.replace(url);
                        }
                    }    
                }
            })
        }
    }


    
    return(
        <>
        <div className="flex border-b pb-2  border-b-[#A5A5A5] justify-between">
            <div className="flex gap-2 text-[18px] pl-4 items-center">
                <WalletIcon/>
                <h4>Πληρωμή</h4>
                    <p className="text-body max-lg:hidden">• Βήμα 1/2</p>
                    <p className="text-body lg:hidden">Βήμα 1/2</p>
            </div>
           <Button disabled={!paymentMethod} onClick={handlePaymentMethod} className={'max-lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-full text-white text-sm font-[600]'}>Επόμενο</Button>
        </div>
        <div className="pt-6 flex flex-col gap-10 lg:container lg:mx-auto"> 
            <div className="flex gap-1 lg:gap-4 bg-[#EFFFED] rounded-[12px] py-4 lg:px-6 px-4 items-center">
                <ApprovedCircled className={'rounded-full h-8 lg:w-8 w-[100px]'}/>
                <p className="text-sm text-[#282828]">Η υπογραφή των συμβολαίων ολοκληρώθηκε με επιτυχία!
Προχώρησε στην πληρωμή για να οριστικοποιήσεις την παραγγελία.</p>
            </div>
            <div className="flex max-lg:flex-col gap-11">
                <div className="flex flex-col gap-6">
                    <h4 className="pl-6">Σύνοψη</h4>
                        {paymentData &&
                        <div className="bg-white rounded-[12px] p-6 lg:w-[26rem] gap-4 flex flex-col max-lg:border max-lg:border-[#A5A5A5]">
                            <div className="w-full flex justify-between text-[#595454] text-sm">
                                <p className="text-body">Πρώτο προσαυξημένο μίσθωμα:</p>
                                    <p className="font-[700]">
                                    {paymentData.amountInitRent.toLocaleString('el-GR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                    })}€</p>
                            </div>
                                <div className="w-full flex justify-between text-[#595454] text-sm">
                                    <div className="flex gap-2 items-center">
                                    <p className="text-body">Εγγύηση:</p>
                                        <TooltipComponent content={<p className="w-[180px] text-center">Η εγγύηση επιστρέφεται άτοκα στη λήξη της περιόδου μίσθωσης.</p>}>
                                            <div>
                                                <InfoIcon />
                                            </div>
                                        </TooltipComponent>
                                    </div>
                                    <p className="font-[700]">
                                    {paymentData.amountWarranty.toLocaleString('el-GR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                    })}€</p>
                                </div>
                                <div className="w-full flex justify-between text-[#595454] text-sm">
                                <p className="text-body">Έξοδα φακέλου:</p>
                                    <p className="font-[700]">
                                    {paymentData.extraChargesVAT.toLocaleString('el-GR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                    })}€</p>
                                </div>
                            <div className="w-full h-[1px] bg-[#A5A5A5]" />
                                <div className="w-full flex justify-between text-[#595454] text-sm">
                                    <div className="flex gap-2">
                                        <p className="text-body">Σύνολο:</p>
                                        <TooltipComponent content={<p className="w-[180px] text-center">	
Οι παραπάνω τιμές περιλαμβάνουν ΦΠΑ 24%.</p>}>
                                            <div>
                                                <InfoIcon />
                                            </div>
                                        </TooltipComponent>
                                    </div>
                                    <p className="font-[700]">{(paymentData.amountWarranty + paymentData.amountInitRent + paymentData.extraChargesVAT).toLocaleString('el-GR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                    })}€</p>
                            </div>
                        </div>
                    }
                </div>
                    <RadioGroup onValueChange={setPaymentMethod}>
                    <div className="flex flex-col gap-6">
                        <h4 className="pl-4">Τρόπος Πληρωμής</h4>
                        <div className="flex flex-col gap-4">
                            <div className="bg-white rounded-[12px] p-4 lg:w-[22rem] flex justify-between items-center border border-[#A5A5A5]">
                                <div className="flex gap-2">
                                    <div className="rounded-full w-10 h-10 bg-[#F5F5F7] flex items-center justify-center">
                                        <CreditCardIcon/>
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <p className="text-sm">Πιστωτική/χρεωστική κάρτα</p>
                                        <p className="text-xs">Χρόνος ολοκλήρωσης 1- 5 λεπτά</p>
                                    </div>
                                </div>
                                    <RadioGroupItem
                                        value={'card'}
                                />
                            </div>
                            <div className="bg-white rounded-[12px] p-4 lg:w-[22rem] border border-[#A5A5A5] flex flex-col gap-4">
                                <div className="flex justify-between items-center">
                                    <div className="flex gap-2">
                                        <div className="rounded-full w-10 h-10 bg-[#F5F5F7] flex items-center justify-center">
                                            <ReceiptIcon className={'stroke-black'}/>
                                        </div>
                                        <div className="flex flex-col gap-1">
                                            <p className="text-sm">Κωδικός ηλεκτρονικής πληρωμής</p>
                                            <p className="text-xs">Χρόνος ολοκλήρωσης 1- 5 εργάσιμες</p>
                                        </div>
                                    </div>
                                        <RadioGroupItem
                                            value={'RFCode'}
                                    />
                                </div>
                                {paymentMethod === 'RFCode' && 
                                    <div className="flex flex-col gap-2">
                                        <div className="flex gap-1 items-center">
                                            <p className="text-label text-[#C1C1C1]">Receipt code</p>
                                            <TooltipComponent content={<p className="w-[300px] text-center">Για πληρωμή μέσω RF (μέσω web banking, mobile banking ή σε τραπεζικό κατάστημα), χρησιμοποίησε τον κωδικό ηλεκτρονικής πληρωμής που αναγράφεται παρακάτω:</p>}>
                                                <div>
                                                    <QuestionIcon className={'cursor-pointer h-4 w-4'}/>
                                                </div>
                                            </TooltipComponent>
                                        </div>
                                        {data?.data.RFCode && (
                                            <div className="flex gap-1 items-center">
                                                <CopyIcon
                                                    onClick={handleCopy}
                                                    className={'hover:cursor-pointer h-6 w-6'}
                                                />
                                                <p className="text-label">{data?.data.RFCode}</p>
                                            </div>
                                        )}    
                                    </div>
                                }
                            </div>
                        </div>
                            </div>
                </RadioGroup>
            </div>
            </div> 
            <Button  disabled={!paymentMethod} onClick={handlePaymentMethod} className={'lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 mt-4 rounded-[6px] text-white text-sm font-[600] w-full'}>Επόμενο</Button>    

        </>
    )
}